import { SubscriptionActionTypes } from "./subscription.type";

const INITIAL_STATE = {
  subscriptionPlans: [],
  totalPlans: 0,
  currentSubscription: null,
};

const subscriptionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Fetch subscriptionPlans
    case SubscriptionActionTypes.GET_SUBSCRIPTIONS:
      return {
        ...state,
        subscriptionPlans: action.payload.plans,
        totalPlans: action.payload.total,
      };

    // Add subscription
    case SubscriptionActionTypes.ADD_SUBSCRIPTION:
      return {
        ...state,
        subscriptionPlans: [action.payload, ...state.subscriptionPlans],
        totalPlans: state.totalPlans + 1,
      };

    // Update subscription
    case SubscriptionActionTypes.UPDATE_SUBSCRIPTION:
      return {
        ...state,
        subscriptionPlans: state.subscriptionPlans.map((sub) =>
          sub._id === action.payload._id ? action.payload : sub
        ),
        currentSubscription: null,
      };

    // Delete subscription
    case SubscriptionActionTypes.DELETE_SUBSCRIPTION:
      return {
        ...state,
        subscriptionPlans: state.subscriptionPlans.filter(
          (sub) => sub._id !== action.payload
        ),
        totalPlans: state.totalPlans - 1,
      };

    case SubscriptionActionTypes.EDITING_PLAN:
      return {
        ...state,
        currentSubscription: action.payload,
      };

    default:
      return state;
  }
};

export default subscriptionReducer;
